












































































































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import Form from '@/mixins/form'
import { ExStore } from 'vuex'
import { PdSettingPayload } from '@/api/pdSetting/types'

@Component({
  components: {
    QualityInputGroup: () => import('./PdTabSettingModalQualityInputGroup.vue'),
    QuantityInputGroup: () =>
      import('./PdTabSettingModalQuantityInputGroup.vue'),
    RadioInput: () => import('@/components/common/inputs/RadioInput.vue')
  }
})
export default class PdTabSettingModalForm extends mixins(Form) {
  @Prop({ type: Number, required: true }) patientId!: number

  $store!: ExStore
  inputs = this.pdSetting as PdSettingPayload
  errorMessage = ''
  pending = false

  inputWasteFluid = {
    emg: [
      { label: 'フィブリン', value: this.inputs.emgIsWasteFluid2 },
      { label: '混濁', value: this.inputs.emgIsWasteFluid3 }
    ],
    warn: [
      { label: 'フィブリン', value: this.inputs.warnIsWasteFluid2 },
      { label: '混濁', value: this.inputs.warnIsWasteFluid3 }
    ]
  }

  inputExitsite = {
    emg: [
      { label: '赤み', value: this.inputs.emgIsExitsite2 },
      { label: '痛み', value: this.inputs.emgIsExitsite3 },
      { label: '腫れ', value: this.inputs.emgIsExitsite4 },
      { label: 'かさぶた', value: this.inputs.emgIsExitsite5 },
      { label: '膿', value: this.inputs.emgIsExitsite6 }
    ],
    warn: [
      { label: '赤み', value: this.inputs.warnIsExitsite2 },
      { label: '痛み', value: this.inputs.warnIsExitsite3 },
      { label: '腫れ', value: this.inputs.warnIsExitsite4 },
      { label: 'かさぶた', value: this.inputs.warnIsExitsite5 },
      { label: '膿', value: this.inputs.warnIsExitsite6 }
    ]
  }

  inputSwelling = {
    emg: [
      { label: '有', value: this.inputs.emgIsSwelling1 },
      { label: '悪化', value: this.inputs.emgIsSwelling2 }
    ],
    warn: [
      { label: '有', value: this.inputs.warnIsSwelling1 },
      { label: '悪化', value: this.inputs.warnIsSwelling2 }
    ]
  }

  get errors() {
    return this.validator.messages
  }

  get pdSetting() {
    return this.$store.getters['pdSetting/pdSetting']
  }

  mounted() {
    this.checkError()
  }

  handleClickClose() {
    this.$emit('close')
  }

  handleClickCancel() {
    this.$emit('close')
  }

  async handleClickSave() {
    this.errorMessage = ''

    if (this.pending) {
      return
    }

    if (this.validator.hasAnyError()) {
      return
    }

    // if (this.validator.hasAnyError()) {
    //   this.errorMessage = this.validator.getFirstErrorMessage()
    //   return
    // }

    this.pending = true

    const patientId = this.patientId
    const payload = { ...this.inputs }

    payload.emgIsWasteFluid2 = Number(this.inputWasteFluid.emg[0].value)
    payload.emgIsWasteFluid3 = Number(this.inputWasteFluid.emg[1].value)

    payload.warnIsWasteFluid2 = Number(this.inputWasteFluid.warn[0].value)
    payload.warnIsWasteFluid3 = Number(this.inputWasteFluid.warn[1].value)

    payload.emgIsExitsite2 = Number(this.inputExitsite.emg[0].value)
    payload.emgIsExitsite3 = Number(this.inputExitsite.emg[1].value)
    payload.emgIsExitsite4 = Number(this.inputExitsite.emg[2].value)
    payload.emgIsExitsite5 = Number(this.inputExitsite.emg[3].value)
    payload.emgIsExitsite6 = Number(this.inputExitsite.emg[4].value)

    payload.warnIsExitsite2 = Number(this.inputExitsite.warn[0].value)
    payload.warnIsExitsite3 = Number(this.inputExitsite.warn[1].value)
    payload.warnIsExitsite4 = Number(this.inputExitsite.warn[2].value)
    payload.warnIsExitsite5 = Number(this.inputExitsite.warn[3].value)
    payload.warnIsExitsite6 = Number(this.inputExitsite.warn[4].value)

    payload.emgIsSwelling1 = Number(this.inputSwelling.emg[0].value)
    payload.emgIsSwelling2 = Number(this.inputSwelling.emg[1].value)

    payload.warnIsSwelling1 = Number(this.inputSwelling.warn[0].value)
    payload.warnIsSwelling2 = Number(this.inputSwelling.warn[1].value)

    try {
      await this.$store.dispatch('pdSetting/update', {
        patientId,
        payload
      })
      this.$emit('close')
    } catch (error) {
      console.error(error)
      this.errorMessage = '保存できませんでした。'
    } finally {
      this.pending = false
    }
  }

  hasError(key: string) {
    return !!this.validator.messages[key]
  }

  checkError() {
    this.validator.hasAnyError()
  }
}
